import SrStep from "./index.vue";

SrStep.install = function(Vue) {
  Vue.component(SrStep.name, SrStep);
};

export default SrStep;



// WEBPACK FOOTER //
// ./packages/SrStep/index.js